module.exports = __webpack_public_path__ + "static/media/Gallery_Slider_1-min.c2ad8596.jpg";